export { default as ContentSlider } from './ContentSlider';
